/* 1) AddHallModal.jsx — lightweight modal matching your screenshot */
import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";

export function AddHallModal({ open, onClose, onSave }) {
  const NAME_MAX = 100;
  const ADDR_MAX = 250;
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [saving, setSaving] = useState(false);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-start justify-center bg-black/40 p-4">
      <ToastContainer />

      <div className="w-full max-w-xl rounded-lg bg-white shadow-xl">
        {/* header */}
        <div className="relative border-b px-5 py-4">
          <div className="text-lg">Add Hall</div>
          <button
            aria-label="close"
            onClick={onClose}
            className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
          >
            ×
          </button>
        </div>

        {/* body */}
        <div className="space-y-5 px-5 py-5">
          <div className="relative">
            <label className="mb-1 block text-sm text-gray-700">
              Name <span className="text-red-600">*</span>
            </label>
            <input
              className="h-11 w-full rounded border border-gray-300 px-3 outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter a hall name"
              value={name}
              onChange={(e) =>
                e.target.value.length <= NAME_MAX && setName(e.target.value)
              }
            />
            <div className="pointer-events-none absolute right-2 top-0 text-xs text-gray-500">
              {name.length} / {NAME_MAX}
            </div>
          </div>

          <div className="relative">
            <label className="mb-1 block text-sm text-gray-700">Address</label>
            <textarea
              rows={4}
              className="w-full rounded border border-gray-300 px-3 py-2 outline-none focus:ring-2 focus:ring-indigo-500"
              placeholder="Enter a hall name"
              value={address}
              onChange={(e) =>
                e.target.value.length <= ADDR_MAX && setAddress(e.target.value)
              }
            />
            <div className="pointer-events-none absolute right-2 top-0 text-xs text-gray-500">
              {address.length} / {ADDR_MAX}
            </div>
          </div>
        </div>

        {/* footer */}
        <div className="flex items-center justify-between border-t px-5 py-4">
          <button
            className="h-10 rounded border border-gray-300 px-4"
            onClick={onClose}
            disabled={saving}
          >
            Cancel
          </button>
          <button
            className="h-10 rounded bg-indigo-600 px-6 text-white hover:bg-indigo-700 disabled:opacity-60"
            onClick={async () => {
              if (!name.trim()) return toast.error("hall name is required");
              try {
                setSaving(true);
                const created = await onSave({
                  name: name.trim(),
                  address: address.trim(),
                  
                });
                // close after successful save
                onClose();
                return created;
              } finally {
                setSaving(false);
              }
            }}
            disabled={saving}
          >
            {saving ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
